import script from "./BusinessInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&setup=true&lang=js"

import "./BusinessInfo.vue?vue&type=style&index=0&id=2f73495b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f73495b"]])

export default __exports__